import { FrontendApplication, FrontendApplicationContribution, WidgetManager } from '@theia/core/lib/browser';
import { Widget } from '@theia/core/lib/browser/widgets/widget';
import { inject, injectable } from '@theia/core/shared/inversify';
import { UpdateAvailableHostWidget } from './update-available-host-widget';

@injectable()
export class UpdateAvailableHostContribution implements FrontendApplicationContribution {
    @inject(WidgetManager)
    protected readonly widgetManager!: WidgetManager;

    async onStart(_app: FrontendApplication): Promise<void> {
        const widget: UpdateAvailableHostWidget = await this.widgetManager.getOrCreateWidget(
            UpdateAvailableHostWidget.ID
        );
        if (!widget.isAttached) Widget.attach(widget, document.body);
    }
}
